import { ReactNode } from 'react';

import DiagnosticsDrawer from './DiagnosticsDrawer';
import DiagnosticsModal from './DiagnosticsModal';
import DiagnosticsToast from './DiagnosticsToast';
import { DiagnosticsContextProvider } from './DiagnosticsContext';

type Props = {
  children?: ReactNode;
};

const DiagnosticsProvider = ({ children }: Props) => {
  return (
    <DiagnosticsContextProvider>
      {children}
      <DiagnosticsToast />
      <DiagnosticsDrawer />
      <DiagnosticsModal />
    </DiagnosticsContextProvider>
  );
};

export default DiagnosticsProvider;
